import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { WorkflowLevel, WorkflowLevelAudience, WorkflowLevelPermissions } from '@core/typings/workflow.typing';
import { AudienceService } from '@features/audience/audience.service';
import { Audience } from '@features/audience/audience.typing';
import { UserService } from '@features/users/user.service';
import { TopLevelFilter } from '@yourcause/common';
import { SelectOption, TypeSafeFormBuilder, TypeSafeFormGroup, TypeaheadSelectOption } from '@yourcause/common/core-forms';
import { I18nService } from '@yourcause/common/i18n';
import { YCModalComponent } from '@yourcause/common/modals';
interface WflGroup {
  workflowLevelIds: number[];
  permission: WorkflowLevelPermissions;
}
export interface BulkWflAudienceModalResponse {
  workflowLevelAudiences: WorkflowLevelAudience[];
}

@Component({
    selector: 'gc-bulk-workflow-level-audience-modal',
    templateUrl: './bulk-workflow-level-audience-modal.component.html',
    styleUrls: ['./bulk-workflow-level-audience-modal.component.scss'],
    standalone: false
})
export class BulkWorkflowLevelAudienceModalComponent extends YCModalComponent<
  BulkWflAudienceModalResponse
> implements OnInit {
  @Input() workflowId: number;
  @Input() workflowLevels: WorkflowLevel[];
  @Input() allLevels: WorkflowLevel[];

  formGroup: TypeSafeFormGroup<WflGroup>;
  workflowLevelOptions: SelectOption[] = [];
  hideModal = false;
  selectedAudiences: Audience[] = [];
  topLevelFilters: TopLevelFilter[] = [
    new TopLevelFilter(
      'text',
      'name',
      '',
      this.i18n.translate(
        'common:textSearchByName',
        {},
        'Search by name'
      )
    )
  ];
  permissionOptions: TypeaheadSelectOption[] = [{
    label: this.i18n.translate(
      'WORKFLOW:textWorkflowPassthrough',
      {},
      'Workflow passthrough'
    ),
    value: WorkflowLevelPermissions.PASSTHROUGH
  }, {
    label: this.i18n.translate(
      'WORKFLOW:textWorkflowLevelOnly',
      {},
      'Workflow level only'
    ),
    value: WorkflowLevelPermissions.LEVEL_ONLY
  }]
  
  constructor (
    private formBuilder: TypeSafeFormBuilder,
    private audienceService: AudienceService,
    private i18n: I18nService,
    private userService: UserService
  ) {
    super();
  }

  async ngOnInit ()  {
    await this.audienceService.setAllAudiences();
    this.workflowLevelOptions = this.allLevels.map((level) => {
      return {
        display: level.name,
        value: level.id
      };
    });
    this.formGroup = this.formBuilder.group<WflGroup>({
      workflowLevelIds: [
        this.workflowLevels.map((level) => level.id),
        Validators.minLength(1)
      ],
      permission: [WorkflowLevelPermissions.LEVEL_ONLY, Validators.required]
    });
  }

  async createAudience () {
    this.hideModal = true;
    await this.audienceService.handleAudienceModal();
    this.userService.resetUserAudienceMap();
    this.hideModal = false;
  }

  onPrimaryClick () {
    const workflowLevelAudiences = this.formGroup.value.workflowLevelIds.reduce((acc, levelId) => {
      return [
        ...acc,
        ...this.selectedAudiences.map<WorkflowLevelAudience>((audience) => {
          return {
            audienceId: audience.id,
            workflowLevelId: levelId,
            workflowId: this.workflowId,
            workflowLevelAccessType: this.formGroup.value.permission
          };
        })
      ];
    }, [] as WorkflowLevelAudience[]);
    this.closeModal.emit({
      workflowLevelAudiences
    });
  }
}
